// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"184":"08ea9497","241":"3592522e","648":"cb2c0ddc"}[chunkId] + ".css";
};